import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import {
  getLayoutSolutionRequest,
  getLayoutSolutionRequestQueryParameters,
  isLayoutSolutionActive as isLayoutSolutionActiveFn,
} from '@/layout-solution/layout-solution';
import { type LayoutSolutionAgencyConfiguration, type LayoutSolutionRequest } from '@/types';

export function useLayoutSolution(): {
  isLayoutSolutionActive;
  layoutSolutionRequest;
  layoutSolutionRequestQueryParameters;
  layoutSolutionAgencyConfiguration;
} {
  const route = useRoute();
  const store = useStore();

  // Computed properties
  const isLayoutSolutionActive = computed(() => {
    return isLayoutSolutionActiveFn(route.query);
  });

  const layoutSolutionRequest = computed(() => {
    return getLayoutSolutionRequest(route.query);
  });

  const layoutSolutionRequestQueryParameters = computed(() => {
    return getLayoutSolutionRequestQueryParameters(
      layoutSolutionRequest.value as LayoutSolutionRequest,
    );
  });

  const layoutSolutionAgencyConfiguration = computed<LayoutSolutionAgencyConfiguration | undefined>(
    () => {
      // Retrieve from store via Vuex getter
      return store.getters['layoutSolution/agencyConfiguration'] || undefined;
    },
  );

  return {
    isLayoutSolutionActive,
    layoutSolutionRequest,
    layoutSolutionRequestQueryParameters,
    layoutSolutionAgencyConfiguration,
  };
}
